module.exports = __webpack_public_path__ + "static/media/edit-icon.b1578353.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/edit-icon.png
 ** module id = 122
 ** module chunks = 0
 **/